import { useCallback } from "react";

import { useAction } from "@/hooks/shared";
import { logoutHandler } from "@/services";
import { clearAuthHandler } from "@/utils";

export const useLogout = () => {
    const action = useAction<[], void>(logoutHandler);

    const runHandler = useCallback(
        async () => {
            try {
                await action.onRun();
            } finally {
                clearAuthHandler();
            }
        },
        [action],
    );

    return {
        ...action,
        onRun: runHandler,
    };
};
